export default __webpack_public_path__ + "static/media/en.2d19fed4.svg";